var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40 41.3 1.4-1.4-3.75-3.75v-5.6h-2v6.4ZM9 42q-1.25 0-2.125-.875T6 39V9q0-1.25.875-2.125T9 6h30q1.25 0 2.125.875T42 9v16.45q-.7-.4-1.475-.65-.775-.25-1.525-.4V9H9v30h15.45q.2.8.45 1.55t.6 1.45Zm0-5.35V39 9v15.4-.2 12.45ZM14 34h10.55q.2-.8.45-1.55t.65-1.45H14Zm0-8.5h17.2q.7-.35 1.35-.575.65-.225 1.45-.425v-2H14Zm0-8.5h20v-3H14Zm22.65 28.95q-3.9 0-6.65-2.775-2.75-2.775-2.75-6.575 0-3.9 2.75-6.675t6.65-2.775q3.85 0 6.625 2.775T46.05 36.6q0 3.8-2.775 6.575Q40.5 45.95 36.65 45.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.14978c5466fee700346cb6a4e0c475ea.svg";
export { ForwardRef as ReactComponent };